import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BonusAvailable, LoginForm, LoyaltyQrResponse } from '@user/const';
import {
  BONUS_BALANCE,
  CustomUserState,
  JOIN_LOYALTY_PROGRAM_ENTITY,
  LOGIN,
  LOYALTY_QR,
  SUBMIT_AUTH_CODE,
} from '../user-state';
import { legalEntityStatusReducer } from './legal-entity-status.reducer';

export function getReducers(): ActionReducerMap<CustomUserState> {
  return {
    bonusBalance: StateUtils.loaderReducer<BonusAvailable>(BONUS_BALANCE),
    login: StateUtils.loaderReducer<LoginForm>(LOGIN),
    submitAuthCode: StateUtils.loaderReducer<string>(SUBMIT_AUTH_CODE),
    legalEntityStatus: legalEntityStatusReducer,
    joinLoyaltyProgram: StateUtils.loaderReducer<void>(JOIN_LOYALTY_PROGRAM_ENTITY),
    loyaltyQr: StateUtils.loaderReducer<LoyaltyQrResponse>(LOYALTY_QR),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CustomUserState>> = new InjectionToken<
  ActionReducerMap<CustomUserState>
>('CustomUserReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
